import config from '../config';

// #154 (S3b, plan v4 §1.2): the portal has ONE entry, the order search
// (`/order-form-page`); return-api routes the lookup to a return or to a
// withdrawal declaration (#408). The withdrawal lookup of #149/#150
// (`/withdrawal`) is gone, but its links and bookmarks still exist, so the
// exact base-relative lookup path is rewritten to the single entry in place,
// BEFORE anything reads the location: this module is the FIRST import of
// index.tsx and imports only the dependency-free runtime config (helpers.tsx
// decides the full-screen QR mode and the remembered shop at module load).
// The declaration (`/withdrawal/form`) and the receipt (`/withdrawal/:id`)
// are untouched. Basename, the complete query (`rq`, proof, shop, language,
// theme), the hash and the history state (a standalone flag included) are
// kept; it is a replace, never a new history entry. Embedded, `window` is the
// iframe: only its own history is rewritten.

const ENTRY = '/order-form-page';
const OLD_LOOKUP = /^\/withdrawal\/?$/;

// the canonical path of `pathname` under the router basename, or null when
// nothing is to be rewritten
export const canonicalEntryPath = (
  pathname: string,
  baseName: string
): string | null => {
  const base = baseName.replace(/\/+$/, '');
  if (base !== '' && !pathname.startsWith(base + '/')) return null;
  const relative = pathname.slice(base.length);
  return OLD_LOOKUP.test(relative) ? base + ENTRY : null;
};

// true when the location was rewritten
export const canonicalizeEntryUrl = (
  win: Window,
  baseName: string
): boolean => {
  try {
    const { pathname, search, hash } = win.location;
    const target = canonicalEntryPath(pathname, baseName);
    if (target === null) return false;
    win.history.replaceState(win.history.state, '', target + search + hash);
    return true;
  } catch {
    // a history that refuses the rewrite: `/withdrawal?rq=` stays a
    // full-screen QR location (qrEntry) and the router's fallback route
    // redirects the old path to the entry (keeping the query)
    return false;
  }
};

if (typeof window !== 'undefined') {
  canonicalizeEntryUrl(window, config.baseName || '');
}
